module.exports = __webpack_public_path__ + "static/media/hamburger.ae904e12.svg";